<template>
    <div class="clientMgt">
        <el-card class="table-card">
            <div>
                <h3 style="margin-bottom:20px">客户管理</h3>
                <div class="table_common_operbar">
                    <el-row style="margin-bottom:10px;">
                        <el-button icon="el-icon-plus" type="primary" size="small" v-if="permission.btn_customer_create" @click="addbtn">新增</el-button>
                    </el-row>
                </div>
                <el-table :data="tableData" stripe style="width: 100%">
                    <el-table-column prop="customerCode" label="客户编码" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="customerName" label="客户名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="trademark" label="商标" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="contacts" label="联系人" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="telephone" label="联系电话" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="email" label="电子邮箱" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" fixed="right" width="150">
                        <template slot-scope="scope">
                            <el-button @click="viewBtn(scope.row)" type="text" size="small">查看</el-button>
                            <el-button @click="editBtn(scope.row)" type="text" size="small" v-if="permission.btn_customer_update">编辑</el-button>
                            <el-button class="btn-del" @click="deleteBtn(scope.row)" v-if="permission.btn_customer_delete" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <div class="total_page"><span> 共{{page.total}}条 {{page.pageSize}}条/页</span></div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:10px;">
                        <el-pagination :page-size="page.pageSize" background layout="prev, pager, next" :total="page.total" @current-change="pageChange" :current-page.sync="page.currentPage"></el-pagination>
                    </div>
                </div>
            </div>
        </el-card>
        <el-dialog :title="title" :visible.sync="dialogVisible" width="25%" center :before-close="cancalDialog">
            <el-form :model="addForm" :rules="rules" ref="addform" label-width="80px" style="width:100%;" class="add_form">
                <el-form-item label="客户编码" prop="customerCode">
                    <el-input size="small"   v-model="addForm.customerCode" maxlength="30" placeholder="客户编码" ></el-input>
                </el-form-item>
                <el-form-item label="客户名称" prop="customerName">
                    <el-input size="small"   v-model="addForm.customerName" maxlength="30" placeholder="客户名称" ></el-input>
                </el-form-item>
                <el-form-item label="商标" prop="trademark">
                    <el-input size="small"   v-model="addForm.trademark" maxlength="20" placeholder="商标" ></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="contacts">
                    <el-input size="small"   v-model="addForm.contacts" maxlength="20" placeholder="联系人" ></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="telephone">
                    <el-input size="small"   v-model="addForm.telephone" maxlength="20" placeholder="联系电话" ></el-input>
                </el-form-item>
                <el-form-item label="电子邮箱" prop="email">
                    <el-input size="small"   v-model="addForm.email" maxlength="30" placeholder="电子邮箱" ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="el-dialog__footer" style="text-align: center;" center>
                <el-button type="primary" @click="saveDialog()">确定</el-button>
                <el-button @click="cancalDialog()" >取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="详情" :visible.sync="viewdialogVisible" width="25%" center>
            <el-row style="margin-bottom:10px;">
                <el-col>
                    <span class="title">客户编码：</span>
                    <span>{{ viewForm.customerCode }}</span>
                </el-col>
            </el-row>
            <el-row style="margin-bottom:10px;">
                <el-col>
                    <span class="title">客户名称：</span>
                    <span>{{ viewForm.customerName }}</span>
                </el-col>
            </el-row>
            <el-row style="margin-bottom:10px;">
                <el-col>
                    <span class="title">商标：</span>
                    <span>{{ viewForm.trademark }}</span>
                </el-col>
            </el-row>
            <el-row style="margin-bottom:10px;">
                <el-col>
                    <span class="title">联系人：</span>
                    <span>{{ viewForm.contacts }}</span>
                </el-col>
            </el-row>
            <el-row style="margin-bottom:10px;">
                <el-col>
                    <span class="title">联系电话：</span>
                    <span>{{ viewForm.telephone }}</span>
                </el-col>
            </el-row>
            <el-row style="margin-bottom:10px;">
                <el-col>
                    <span class="title">电子邮箱：</span>
                    <span>{{ viewForm.email }}</span>
                </el-col>
            </el-row>
            <div slot="footer" class="el-dialog__footer" style="text-align: center;" center>
                <el-button type="primary" @click="viewSaveDialog()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            dialogVisible:false,
            title:'新增',
            addForm:{
                id:'',
                customerCode:'',
                customerName:'',
                trademark:'',
                contacts:'',
                telephone:'',
                email:''
            },
            rules:{
                customerCode:[
                    { required: true, message: '请输入客户编码', trigger: 'blur' }
                ],
                customerName:[
                    { required: true, message: '请输入客户名称', trigger: 'blur' }
                ]
            },
            viewdialogVisible:false,
            viewForm:{
                id:'',
                customerCode:'',
                customerName:'',
                trademark:'',
                contacts:'',
                telephone:'',
                email:''
            },
            page: {
                total: 0,
                pageSize: 10,
                currentPage: 1
            },
            tableData:[],
            permission:JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted(){
        this.search(1)
    },
    methods:{
        pageChange(pageNum){
            this.search(pageNum)
        },
        search(pageNum){
            this.$RequestUtil.get({
                url: '/api/customer/page',
                type:'sync',
                params: {
                    pageNum: pageNum,
                    pageSize: this.page.pageSize,
                },
                success: (res) => {
                    if(res.code==0){
                        this.tableData = res.data.list;
                        this.page.total = res.data.total;
                        this.page.currentPage = res.data.pageNum;
                    }
                }
            })
        },
        addbtn(){
            this.title = '新增';
            this.dialogVisible = true;
        },
        editBtn(row){
            Object.keys(this.addForm).forEach((val)=>{
                this.addForm[val] = row[val];
            })
            this.title = '编辑';
            this.dialogVisible = true;
        },
        saveDialog(){
            this.$refs["addform"].validate(valid => {
                if (valid) {
                    if(!this.addForm.id){//新增
                        this.$RequestUtil.post({
                            url: `/api/customer/create`,
                            type:'sync',
                            params: this.addForm,
                            success: (res) => {
                                if(res.code==0){
                                    this.$message.success('新增成功');
                                    this.search(1);
                                    this.cancalDialog()
                                    this.dialogVisible = false;
                                }else{
                                    this.$message.error(res.message);
                                }
                                
                            }
                        })
                    }else{//编辑
                        this.$RequestUtil.post({
                            url: `/api/customer/update`,
                            type:'sync',
                            params: this.addForm,
                            success: (res) => {
                                if(res.code==0){
                                    this.$message.success('编辑成功');
                                    this.search(1);
                                    this.cancalDialog()
                                    this.dialogVisible = false;
                                }else{
                                    this.$message.error(res.message);
                                }
                            }
                        })
                    }
                }
            })
           
        },
        cancalDialog(){
            this.$refs.addform.resetFields();
            Object.keys(this.addForm).forEach((val)=>{
                this.addForm[val] = '';
            })
            this.dialogVisible = false;
        },
        viewBtn(row){
            Object.keys(this.viewForm).forEach((val)=>{
                this.viewForm[val] = row[val];
            })
            this.viewdialogVisible = true;
        },
        viewSaveDialog(){
            this.viewdialogVisible = false;
        },
        deleteBtn(row){
            this.$confirm(`是否确认删除?`, '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.get({
                    url: '/api/customer/delete',
                    type:'sync',
                    params: {
                        id:row.id
                    },
                    success: (res) => {
                        if(res.code==0){
                            this.$message.success('删除成功');
                            this.search(1);
                        }else{
                            this.$message.error(res.message);
                        }
                    }
                })
            })
        }
    }
}
</script>
<style scoped>
.page{
    display: flex;
    justify-content: flex-end;
}

.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/masterdata/ClientMgt.vue